import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHED: `${NAME}/FETCHED`,
  FETCHING: `${NAME}/FETCHING`,
  FETCH_QUOTE_SHIPMENTS: `${NAME}/FETCH_QUOTE_SHIPMENTS`,
  FETCHING_QUOTE_SHIPMENTS: `${NAME}/FETCHING_QUOTE_SHIPMENTS`,
  FETCHED_QUOTE_SHIPMENTS: `${NAME}/FETCHED_QUOTE_SHIPMENTS`,
  UPDATE_DISTANCE: `${NAME}/UPDATE_DISTANCE`,
  UPDATE_DURATION: `${NAME}/UPDATE_DURATION`,
};
